import { render } from "./IconCar.vue.js?vue&type=template&id=2dac2e17!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconCar.vue?vue&type=template&id=2dac2e17"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__